import React from 'react';
const SubmissionIcon = () => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25.5" cy="25.5" r="25.5" fill="#D9DBDF" />
    <path
      d="M20.1983 17.0014C18.8186 16.9739 17.2249 17.347 15.5612 18.0767C15.1399 18.2614 14.875 18.6895 14.875 19.1482V32.2939C14.875 32.7185 15.3173 33.0126 15.7032 32.8324C20.3624 30.6584 23.8117 33.2368 23.9593 33.3474C24.0644 33.4283 24.1898 33.4688 24.3189 33.4688C24.7764 33.4688 24.9092 33.0504 24.9092 32.8813V18.7659C24.9092 18.5747 24.8158 18.3954 24.659 18.2851C24.5882 18.2344 22.8691 17.0496 20.1983 17.0014ZM35.4377 18.0767C33.7736 17.3492 32.1736 16.9882 30.8006 17.0011C28.1282 17.0493 26.4438 18.2344 26.3405 18.2847C26.1819 18.3954 26.0897 18.5744 26.0897 18.7659V32.849C26.0897 33.0423 26.2188 33.4688 26.6799 33.4688C26.8084 33.4688 26.9359 33.4274 27.0407 33.3464C27.1855 33.2355 30.6353 30.657 35.2968 32.8318C35.6827 33.0117 36.125 32.7176 36.125 32.2932L36.125 19.1476C36.0907 18.6898 35.8582 18.2612 35.4377 18.0767Z"
      fill="#8E949E"
    />
  </svg>
);

export default SubmissionIcon;
